/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'service-engine';
const componentName = 'traffic-capture-modal-service';
const prefix = `${moduleName}.${componentName}`;

export const exportModalName = `${prefix}.exportModalName`;

export const ENGLISH = {
    [exportModalName]: 'traffic capture',
};
